import React, {Component} from "react";
import {IconProps, getIconClassName} from "components/Icon";
import { ReactComponent as BookingsImage } from 'assets/img/icons/stats/bookings.svg';
import { ReactComponent as BookingDurationImage } from 'assets/img/icons/stats/booking_duration.svg';
import { ReactComponent as BookingsPerDealImage } from 'assets/img/icons/stats/bookings_per_deal.svg';
import { ReactComponent as DealsImage } from 'assets/img/icons/stats/deals.svg';
import { ReactComponent as RevenueImage } from 'assets/img/icons/stats/revenue.svg';
import { ReactComponent as RevenuePerBookingImage } from 'assets/img/icons/stats/revenue_per_booking.svg';
import { ReactComponent as RevenuePerDealImage } from 'assets/img/icons/stats/revenue_per_deal.svg';
import { ReactComponent as RevenuePerMonthImage } from 'assets/img/icons/stats/revenue_per_month.svg';
import { ReactComponent as RevenuePerWeekImage } from 'assets/img/icons/stats/revenue_per_week.svg';


export class BookingIcon extends Component<IconProps> {
  render() {
    return <BookingsImage className={getIconClassName(this.props)} />;
  }
}

export class BookingDurationIcon extends Component<IconProps> {
  render() {
    return <BookingDurationImage className={getIconClassName(this.props)} />;
  }
}

export class BookingsPerDealIcon extends Component<IconProps> {
  render() {
    return <BookingsPerDealImage className={getIconClassName(this.props)} />;
  }
}

export class DealsIcon extends Component<IconProps> {
  render() {
    return <DealsImage className={getIconClassName(this.props)} />;
  }
}

export class RevenueIcon extends Component<IconProps> {
  render() {
    return <RevenueImage className={getIconClassName(this.props)} />;
  }
}

export class RevenuePerBookingIcon extends Component<IconProps> {
  render() {
    return <RevenuePerBookingImage className={getIconClassName(this.props)} />;
  }
}

export class RevenuePerDealIcon extends Component<IconProps> {
  render() {
    return <RevenuePerDealImage className={getIconClassName(this.props)} />;
  }
}

export class RevenuePerMonthIcon extends Component<IconProps> {
  render() {
    return <RevenuePerMonthImage className={getIconClassName(this.props)} />;
  }
}

export class RevenuePerWeekIcon extends Component<IconProps> {
  render() {
    return <RevenuePerWeekImage className={getIconClassName(this.props)} />;
  }
}